export { default as Modal, ModalProps } from "./Modal.component";